export default "__VITE_ASSET__CaLBhsMX__"